/** Supabase Auth needs an email; we map username → synthetic address. */
export const ADMIN_EMAIL_DOMAIN = "admin.giustini.local";

export function usernameToEmail(username) {
  const clean = String(username || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]/g, "");
  if (!clean) return "";
  return `${clean}@${ADMIN_EMAIL_DOMAIN}`;
}

export function emailToUsername(email) {
  const value = String(email || "").trim().toLowerCase();
  const suffix = `@${ADMIN_EMAIL_DOMAIN}`;
  if (value.endsWith(suffix)) return value.slice(0, -suffix.length);
  return value.split("@")[0] || value;
}
